<template lang="html">

  <div>


    <div class="row">
      <div class="fretboardContainer" ref="fretboardContainer" v-bind:class="isLefty ? 'perspective_sx' : 'perspective'">

        <div class="fretboardWood">
          <div v-for="s in numStrings" class='fretRow' :key="'s'+s">


            <div class="nut" :style="getFretStyle(0)"></div>

            <div class="fretDivider" :style="getFretStyle(f -1)" v-for="f in numFrets" :key="'f'+f"></div>

            <div class="fretMarker" v-show="computeShowMarker(s,f)" :style="getMarkerStyle(f -1)" v-for="f in numFrets" :key="'m'+f"></div>


            <div class="string" :class="getStringClass(s)"></div>

            <Fret v-for="f in numFrets"
                  :key="'i'+f"
                  :show-tones="showTones"
                  :fretClass="'fret'"
                  :style="getFretStyle(f -1)"
                  :my-fret="f-1"
                  :my-string="s-1"
                  :item="guitar.matrix[s-1][f-1]"
                  :root="root"/>
            <div class="clear"></div>

          </div>
        </div>

        <div class="fretRow" style="background-color: #f2f2f3!important;">
          <div v-for="f in numFrets" :key="'fn'+f" :style="getFretStyle(f -1)" class="fretNumberApp">{{ f - 1 }}</div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>

import Fret from './Fret.vue'

export default {
  components: {
    Fret
  },
  props: {
    guitar: Object,
    showTones:Boolean,
    root:Number,
  },

  computed: {



    numFrets() {
      return this.guitar.getNumFrets();
    },

    numStrings() {
      return this.guitar.getNumStrings();
    }
  },

  data() {
    return {
      fretStyles: [],
      isLefty: false,

    }
  },

  created() {
    window.addEventListener('resize', this.computeFretStyles);
  },

  destroyed() {
    window.removeEventListener('resize', this.computeFretStyles);
  },

  mounted() {
    this.computeFretStyles();
  },


  methods: {

    computeShowMarker(s, f) {

      let frets = [3, 5, 7, 9, 15, 17, 19, 21, 24];
      if (frets.includes(f - 1) === true && s === 4) {
        return true
      }

      if ((f - 1) === 12 && (s === 2 || s === 6)) {
        return true
      }
      return false;

    },


    computeFretStyles() {

      this.fretStyles = [];
      //Prende larghezza tastiera da DIV
      let fretboardWidth = this.$refs.fretboardContainer.clientWidth;

      //Larghezza e sfondo nut
      let nutWidth = 40;
      //this.fretStyles.push('left: ' + 0 + 'px;width: ' + nutWidth + 'px')
      this.fretStyles.push({'left': 0, 'width': nutWidth})

      // Larghezza Primo tasto
      let scaleFactor = 0.944;
      let fc = (Math.pow(scaleFactor, (this.numFrets - 1)) - 1) / (scaleFactor - 1.0);
      let fretWidth = (fretboardWidth - nutWidth) / fc;
      let leftPointer = nutWidth;

      for (let f = 1; f < this.numFrets + 1; f++) {

        // this.fretStyles.push('left: ' + leftPointer + 'px; width: ' + fretWidth + 'px')
        this.fretStyles.push({'left': leftPointer, 'width': fretWidth})

        //dati per prossimo tasto
        leftPointer = leftPointer + fretWidth;
        fretWidth = fretWidth * scaleFactor;
      }


      /*    if (this.isLefty === true){
            let lastFret = this.fretStyles[this.fretStyles.length-1];
            for (let i=0;i<this.fretStyles.length;i++){
              this.fretStyles
            }
          }
        last = self.frets[-1]
        for i in range(0, len(self.frets)):
            self.frets[i] = last - self.frets[i]*/



    },


    switchLayout() {
      this.isLefty = !this.isLefty;
      this.computeFretStyles();
    },


    getFretStyle(f) {

      let style = this.fretStyles[f];
      if (style !== undefined) {
        return 'left: ' + style.left + 'px; width: ' + style.width + 'px';
      }
      return undefined
    },

    getMarkerStyle(f) {
      let style = this.fretStyles[f];
      if (style !== undefined) {
        let left = style.left + (style.width / 2) - 10;
        return 'left: ' + left + 'px';
      }
      return undefined;
    },


    getStringClass(s) {
      if (s === 6) {
        return "string_6"
      }
      if (s === 5) {
        return "string_5"
      }
      if (s === 4) {
        return "string_4"
      }
      if (s === 3) {
        return "string_3"
      }
      if (s === 2) {
        return "string_2"
      }
      if (s === 1) {
        return "string_1"
      }

      return ""
    },
  }
}
</script>

<style>
.fretboardContainer {
  width: 100%;
  max-width: 1400px;
  overflow: hidden;

  padding: 0px;
  position: relative;


  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
}


.fretDivider {
  position: absolute;
  height: 35px;
  float: left;
  border-right: 6px solid rgb(192, 192, 192);
  -webkit-border-image: url("/static/fachords3/tools/media/metal.jpg") 6 repeat;
  -moz-border-image: url("/static/fachords3/tools/media/metal.jpg") 6 repeat;
  -o-border-image: url("/static/fachords3/tools/media/metal.jpg") 6 repeat;
  border-image: url("/static/fachords3/tools/media/metal.jpg") 6 repeat;
  pointer-events: none;
  z-index: 1;
}

.fretRow {
  height: 35px;
}

.nut {
  background-color: #787878;
  position: absolute;
  height: 35px;
}

.string {
  position: absolute;
  left: -10px;
  right: 0px;
  height: 4px;
  margin-top: 15.0px;

  cursor: none;
  z-index: 2;
  box-shadow: 2px 2px 4px black;
  /* background:linear-gradient(gray, lightgray, gray);*/
  background-color: gray;
  background-image: url("/static/fachords3/tools/media/string.jpg");
  background-repeat: repeat-x;
  pointer-events: none;
}

.fretNumberApp {
  position: absolute;
  height: 35px;
  float: left;
  text-align: center;
  pointer-events: none;

}

.perspective {
  transform: perspective(900px) rotateY(-5deg) translateX(-2%);
  -webkit-transform: perspective(900px) rotateY(-5deg) translateX(-2%);
  -moz-transform: perspective(900px) rotateY(-5deg) translateX(-2%);
  -ms-transform: perspective(900px) rotateY(-5deg) translateX(-2%);
  -o-transform: perspective(900px) rotateY(-5deg) translateX(-2%);
}

.perspective_sx {
  transform: perspective(900px) rotateY(+5deg) translateX(+1%);
  -webkit-transform: perspective(900px) rotateY(+5deg) translateX(+1%);
  -moz-transform: perspective(900px) rotateY(+5deg) translateX(+1%);
  -ms-transform: perspective(900px) rotateY(+5deg) translateX(+1%);
  -o-transform: perspective(900px) rotateY(+5deg) translateX(+1%);

}


.string_1 {
  height: 4px !important;;
}

.string_2 {
  height: 5px !important;;
}

.string_3 {
  height: 5px !important;;
}

.string_4 {
  height: 7px !important;;
}

.string_5 {
  height: 8px !important;;
}

.string_6 {
  height: 9px !important;
}


</style>
